export default {
  getRightDrawerCollapsers(state) {
    return state.rightDrawerCollapsers;
  },
  getSingleDate: function (state) {
    return state.selectedFilters.singleDate.format("YYYY/MM/DD");
  },
  getDatePickerState(state) {
    return state.singularDatePicker;
  },
  isDrawerEmpty: function (state) {
    let obj = JSON.parse(JSON.stringify(state.selectedFilters));

    if (
      obj.product.hierarchy.marca.length === 0 ||
      obj.store.hierarchy["marca"] === undefined ||
      obj.geography.hierarchy["distrito"] === undefined
    ) {
      return true;
    } else {
      return false;
    }
  },
  getRightDrawerState(state) {
    return state.rightDrawer;
  },
  getHierarchyLevelElementLabels(state) {
    let returnObject = {
      product: [],
      store: [],
      geography: [],
    };

    Object.values(state.selectedFilters.product.hierarchy).forEach(
      (elementIds) => {
        let labels = [];
        elementIds.forEach((elementId) => {
          let label = null;
          label = state.hierarchyLevelElements
            .filter((i) => i.id === elementId)
            .pop().name;
          labels.push(label);
        });
        returnObject.product.push(labels.join(", "));
      }
    );

    Object.values(state.selectedFilters.store.hierarchy).forEach(
      (elementIds) => {
        let labels = [];
        elementIds.forEach((elementId) => {
          let label = null;
          label = state.hierarchyLevelElements
            .filter((i) => i.id === elementId)
            .pop().name;
          labels.push(label);
        });
        returnObject.store.push(labels.join(", "));
      }
    );

    Object.values(state.selectedFilters.geography.hierarchy).forEach(
      (elementIds) => {
        let labels = [];
        elementIds.forEach((elementId) => {
          let label = null;
          label = state.hierarchyLevelElements
            .filter((i) => i.id === elementId)
            .pop().name;
          labels.push(label);
        });
        returnObject.geography.push(labels.join(", "));
      }
    );

    return returnObject;
  },
  getCustomFilters(state) {
    return state.customFilters;
  },
  getHierarchyByKey(state) {
    return function (hierarchy, key) {
      return state.selectedFilters[hierarchy].hierarchy[key];
    };
  },
  getProductHierarchy(state) {
    return state.selectedFilters.product.hierarchy;
  },
  getStoreHierarchy(state) {
    return state.selectedFilters.store.hierarchy;
  },
  getSelectedRetailers(state) {
    return state.selectedFilters.store.hierarchy.retalhista;
  },
  getGeographyHierarchy(state) {
    return state.selectedFilters.geography.hierarchy;
  },
  getDateRange(state) {
    return {
      from: state.selectedFilters.startDate.format("YYYY/MM/DD"),
      to: state.selectedFilters.endDate.format("YYYY/MM/DD"),
    };
  },
  getProductList(state) {
    return state.selectedFilters.product.productList;
  },
  getStoreList(state) {
    return state.selectedFilters.store.storeList;
  },
  getNielsenList(state) {
    return state.selectedFilters.geography.nielsenList;
  },
  getDaysWithoutSales: function (state) {
    return state.customFilters.dwsa_aggreg;
  },
  getCoverageDaysView: function (state) {
    return state.customFilters.coverage_days;
  },
  getAbcSelected: function (state) {
    return state.customFilters.abcSelected;
  },
  getCardexStatus: function (state) {
    return state.customFilters.cardexStatus;
  },
  getEmployeeList(state) {
    return state.selectedFilters.employee.employeeList;
  },
};
